import { defineStore } from "pinia";
import { get, pick } from "lodash-es";
import { useAxios } from "@/config";
import { useOrgSettings } from ".";
import { GammaAccuracy } from "@/types/location/location-accuracy";

const api = {
  base: "https://api.autoaddress.ie/2.0/",
  findAddress: "findaddress/",
  getEcadData: "getEcadData/",
  getGBPostcodeData: "getgbpostcodedata/",
  getGBBuildingData: "getgbbuildingdata/",
  autocomplete: "autocomplete/",
  reverseGeocode: "reversegeocode/",
  dynamicLicenceKey: "dynamiclicencekey/",
};

export const AutoAddressGammaPrecision: Record<number, GammaAccuracy> = {
  0: 421,
  1: 212,
  2: 213,
  3: 211,
  4: 214,
  5: 221,
  6: 222,
  7: 224,
  8: 225,
  9: 226,
};

interface AutoaddressState {
  country: string;
}
export const useAutoaddress = defineStore("autoaddress", {
  state: (): AutoaddressState => ({
    country: "IE",
  }),
  actions: {
    async getLatLng({
      ecadid,
      postcode,
      country,
    }: {
      ecadid: number;
      postcode: string;
      country: string;
    }) {
      if (country.toLowerCase() === this.country) {
        return useAxios()
          .$http.get(api.base + api.getGBPostcodeData, {
            params: {
              key: useOrgSettings().autoAddressProvider?.licenceKey,
              postcode: postcode,
              country,
            },
          })
          .then((r) => r.data);
      } else {
        return useAxios()
          .$http.get(api.base + api.getEcadData, {
            params: {
              key: useOrgSettings().autoAddressProvider?.licenceKey,
              ecadid,
              country,
            },
          })
          .then((r) => r.data);
      }
    },
    async reverseGeocode(coords: { latitude: number; longitude: number }) {
      return useAxios()
        .$http.get(api.base + api.reverseGeocode, {
          params: {
            key: useOrgSettings().autoAddressProvider?.licenceKey,
            ...coords,
            maxDistance: 100,
            vanityMode: true,
          },
        })
        .then(async (r) => {
          if (get(r, "data.hits.length")) {
            const result = r.data.hits[0];
            const ecadData = await this.getLatLng(result.addressId);
            return {
              findAddress: pick(result, [
                "addressId",
                "vanityAddress",
                "distance",
              ]),
              ecadData,
            };
          }
          return r.data;
        });
    },
  },
});
